import { callDecimal } from "../utils.ts";

export function subscribe(email: string) {
  return callDecimal("/api/v1/users/subscriptions", {
    method: "POST",
    body: JSON.stringify({
      email,
    }),
  });
}
